/* KitchenBuildr product card: quick add to basket without leaving the page.
   Opens the theme's cart drawer / notification when present, otherwise refreshes the header bubble.
   Works on cards rendered later (filters, load more, recommendations) via event delegation. */
(function () {
  if (window.KBProductCard) return;

  var CART_ADD = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js';
  var CART_JS = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js';
  var DEFAULT_ERROR = 'Sorry, this item could not be added.';

  function sectionInner(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector('.shopify-section');
    return el ? el.innerHTML : null;
  }

  function findCart() {
    // On the cart page the page itself updates (kb:cart:added), so don't open the drawer over it.
    if (document.querySelector('kb-cart')) return null;
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function setCartCount(count) {
    document.querySelectorAll('[data-kb-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  function refreshCartCount() {
    if (!document.querySelector('[data-kb-cart-count]')) return;
    fetch(CART_JS, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) setCartCount(cart.item_count); })
      .catch(function () {});
  }

  function bumpCardQty(card, qty) {
    var badge = card && card.querySelector('[data-kb-card-qty]');
    if (!badge) return;
    var value = badge.querySelector('[data-kb-card-qty-value]');
    var next = (parseInt(badge.dataset.count, 10) || 0) + qty;
    badge.dataset.count = next;
    if (value) value.textContent = next;
    badge.hidden = false;
  }

  function onSubmit(event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains('kb-card__form')) return;
    if (!window.fetch || !window.FormData) return; // plain form post fallback

    var button = form.querySelector('[data-kb-quick-add]');
    if (!button) return;
    event.preventDefault();
    if (button.disabled || button.classList.contains('is-loading')) return;

    var card = form.closest('[data-kb-card]');
    var errorEl = card && card.querySelector('[data-kb-card-error]');
    var statusEl = card && card.querySelector('[data-kb-card-status]');
    var label = button.querySelector('[data-kb-cta-label]');
    var labelText = label ? label.textContent : '';
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

    var cart = findCart();
    var formData = new FormData(form);
    var qty = parseInt(formData.get('quantity'), 10) || 1;
    var sections = [];

    if (cart && typeof cart.getSectionsToRender === 'function') {
      try { sections = cart.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) { sections = []; }
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
    } else if (document.getElementById('cart-icon-bubble')) {
      sections = ['cart-icon-bubble'];
    }
    if (sections.length) {
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    fetch(CART_ADD, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: formData
    })
      .then(function (response) {
        return response.json().then(function (data) { return { ok: response.ok, data: data }; });
      })
      .then(function (result) {
        var data = result.data || {};
        if (!result.ok || data.status) throw new Error(data.description || data.message || DEFAULT_ERROR);

        if (cart && typeof cart.renderContents === 'function') {
          try { cart.classList.remove('is-empty'); cart.renderContents(data); } catch (e) {}
        } else if (data.sections && data.sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          var inner = sectionInner(data.sections['cart-icon-bubble']);
          if (bubble && inner !== null) bubble.innerHTML = inner;
        }

        try {
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'kb-product-card', productVariantId: formData.get('id'), cartData: data });
          }
        } catch (e) {}
        document.dispatchEvent(new CustomEvent('kb:cart:added', { detail: data }));

        bumpCardQty(card, qty);
        refreshCartCount();

        button.classList.remove('is-loading');
        button.classList.add('is-added');
        if (label) label.textContent = button.dataset.addedText || 'Added';
        if (statusEl) statusEl.textContent = (data.product_title || data.title || 'Item') + ' added to basket';
        setTimeout(function () {
          button.classList.remove('is-added');
          if (label) label.textContent = labelText;
          if (statusEl) statusEl.textContent = '';
        }, 2500);
      })
      .catch(function (error) {
        button.classList.remove('is-loading');
        if (errorEl) {
          errorEl.textContent = (error && error.message) || DEFAULT_ERROR;
          errorEl.hidden = false;
        }
      })
      .finally(function () {
        button.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('submit', onSubmit);

  // Keep [data-kb-cart-count] in step when the cart changes elsewhere (product page, cart drawer).
  try {
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!event || event.source !== 'kb-product-card') refreshCartCount();
      });
    }
  } catch (e) {}

  window.KBProductCard = { refreshCartCount: refreshCartCount };
})();